import { createFeatureSelector, createSelector } from '@ngrx/store';
import { organizationFeatureKey, OrganizationState } from './organization.reducer';

export const selectOrganizationState =
  createFeatureSelector<OrganizationState>(organizationFeatureKey);

export const selectAllOrganizations = createSelector(
  selectOrganizationState,
  (state) => state?.organizations ?? []
);

export const selectOrganizationLoading = createSelector(
  selectOrganizationState,
  (state) => state?.loading ?? false
);

export const selectOrganizationError = createSelector(
  selectOrganizationState,
  (state) => state?.error ?? null
);

export const selectSelectedOrganizationId = createSelector(
  selectOrganizationState,
  (state) => state?.selectedOrganizationId ?? null
);

export const selectSelectedOrganization = createSelector(
  selectAllOrganizations,
  selectSelectedOrganizationId,
  (organizations, selectedOrganizationId) =>
    organizations.find((organization) => organization.id === selectedOrganizationId) ?? null
);
